import * as React from "react";
import { toastr } from "react-redux-toastr";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { useHistory, useParams } from "react-router-dom";
import api from "../../api";
import { ContainerLoader } from "../../components/loader";
import {
  AppLayout,
  Column,
  Customer,
  Dict,
  FilterValueType,
  ListColumnSettings,
  ListEntityType,
  SavedFilter
} from "../../core";
import { Property } from "../../core/api/models/property";
import "../../styles/full-view-popup.scss";
import "../../styles/sales-person.scss";
import "../../styles/tags.scss";
import GeneralInfoTab from "./GeneralInfoTab";
import Tabs from "./Tabs";
import AttributeInfoTab from "./attributesInfoTab";
import AmenitiesTab from "./mediaGallery";
import PeopleTab from "./peopleTab";
import { TabNames } from "./props";

interface IPropertyDetailsPageProps {}

const PropertyDetailsPage: React.FunctionComponent<IPropertyDetailsPageProps> = (
  props
) => {
  const history = useHistory();
  const params = useParams<{ propertyId: string }>();
  const propertyId = params.propertyId;
  const [tabName, setTabName] = React.useState<TabNames>(TabNames.GeneralInfo);
  const handleTabChange = (tabNameValue: TabNames) => {
    setTabName(tabNameValue);
  };

  const { data: leadSettings, reload: reloadSettings } = useDataLoader<{
    filters: SavedFilter[];
    columnSettings?: ListColumnSettings;
  }>(() => api.settings.getListColumnSettings(ListEntityType.Project));

  const {
    performAction: saveFilter,
    isPerforming: savingFilter,
  } = usePerformAction(
    (fls: Dict<FilterValueType>, name: string) =>
      api.settings.saveFilter(fls, name, ListEntityType.Project),
    () => {
      toastr.success("Success", "Filter Saved");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to save filter");
    }
  );

  const { performAction: removeFilter } = usePerformAction(
    (_id: string) => api.settings.removeSavedFilter(_id),
    () => {
      toastr.success("Success", "Filter Removed");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to remove filter");
    }
  );

  const { performAction: saveColumnSettings } = usePerformAction(
    (cols: Column[]) =>
      api.settings.saveListColumnSettings(cols, ListEntityType.Project),
    reloadSettings
  );
  const [isSyncing, setSyncing] = React.useState(false);
  const { data, loading, loaded, reload } = useDataLoader<Property>(
    (id: string) => api.property.getPropertyDetails(id),
    [propertyId]
  );

  const onClose = () => {
    history.goBack();
  };

  React.useEffect(() => {
    if (params.propertyId) {
      updateSearchView(params.propertyId);
    }
  }, [params.propertyId]);

  const updateSearchView = async (id: string) => {
    try {
      const response = await api.globalSearch.updateSearchView(id, "Property");
    } catch (error) {
      // console
    }
  };

  const renderHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={onClose}>
            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
          </div>
          <div className="col">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb font-lg">
                <li className="breadcrumb-item font-weight-semibold">
                  Property Details
                </li>
                <li className="breadcrumb-item font-weight-bold">
                  {data?.propertyName}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    );
  };

  return (
    <AppLayout>
      <div className="">
        {(!loaded || loading) && <ContainerLoader></ContainerLoader>}
        {/* {isSyncing && <ContainerLoader></ContainerLoader>} */}

        {loaded && !loading && propertyId && data && (
          <>
            <div className="detail-poupup position-fixed top-0 w-100 h-100 overflow-auto in">
              {renderHeader()}
              <div className="container-fluid p-4 bg-white min-vh-100">
                <div className="row px-4">
                  <Tabs tabName={tabName} tabChangeHandler={handleTabChange} />
                </div>
                {tabName === TabNames.GeneralInfo && (
                  <GeneralInfoTab
                    property={data}
                    reload={() => reload(propertyId)}
                  ></GeneralInfoTab>
                )}
                {tabName === TabNames.AmenitiesTab && (
                  <AmenitiesTab
                    property={data}
                    reload={() => reload(propertyId)}
                  ></AmenitiesTab>
                )}
                {tabName === TabNames.AttributeInfo && (
                  <AttributeInfoTab
                    property={data}
                    reload={() => reload(propertyId)}
                  ></AttributeInfoTab>
                )}
                {tabName === TabNames.People && (
                  <PeopleTab propertyId={params.propertyId}></PeopleTab>
                )}
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </div>
    </AppLayout>
  );
};

export default PropertyDetailsPage;
